<template>
    <svg :height="height" :width="width" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M10.14,1.16a11,11,0,0,0-9,8.92A1.59,1.59,0,0,0,2.46,12,1.52,1.52,0,0,0,4.11,10.7a8,8,0,0,1,6.66-6.61A1.42,1.42,0,0,0,12,2.69h0A1.57,1.57,0,0,0,10.14,1.16Z"
            class="spinner"
            :fill="color"
        />
    </svg>
</template>

<script>
export default {
    name: 'Spinner',
    props: {
        color: {
            type: String,
            required: false,
            default: '#25C8C1',
        },
        height: {
            type: Number,
            required: false,
            default: 24,
        },
        width: {
            type: Number,
            required: false,
            default: 24,
        },
    },
}
</script>
<style>
@keyframes spinAnim {
    100% {
        transform: rotate(360deg)
    }
}

.spinner {
    transform-origin: center;
    animation: spinAnim .75s infinite linear
}
</style>
